import {createApp} from "vue";
import BookColumnEmpathy from "./bookcolumn/AppEmpathy.vue";
import ColumnEmpathy from "./column/AppEmpathy.vue";

document.addEventListener("DOMContentLoaded", () => {
  const empathyComponents = document.querySelectorAll('.js-empathy');
  for (const empathyComponent of empathyComponents) {
    const app = empathyComponent.dataset.type === 'writing' ? createApp(ColumnEmpathy) : createApp(BookColumnEmpathy);
    app.provide('id', Number(empathyComponent.dataset.id));
    app.mount(empathyComponent);
  }
});
